import "./media.css";
import {
  React,
  useEffect,
  memo,
  useCallback,
  toast,
  useState,
  LoadingSpinner,
  captureeventbaseanalytics,
  capturepageanalytics,
  Box,
  swal,
  TabView,
  TabPanel,
  GetAllImagesFromCloud,
  GetAllVideosFromCloud,
  useDeletemediaMutation,
  useEnquiremediaMutation,
  useGetMediaMutation,
  GetAllLiveStreamsFromCloud,
  GetCookie,
  useAddMediatoAsOfflineMutation,
  Button,
  BASEURL,
  axios,
} from "../../Libraries/Media/index";
import UploadIcon from "@mui/icons-material/Upload";
import { Widgets } from "../../components/InvestingWidgets/widgets";
import { useRef } from "react";
import { CONTENT_BASEURL, MAX_UPLOAD_FILE_SIZE } from "../../Utils/Constants/constants";
// const fileTypes = ["JPG", "PNG", "mp4"];

const Media = () => {
  const fileInputRef = useRef(null);
  const [getMedia, { isLoading }] = useGetMediaMutation();
  const [enquireMedia] = useEnquiremediaMutation();
  const [DeleteMedia] = useDeletemediaMutation();
  const [addMediatoAsOffline, { isLoading: loading }] =
    useAddMediatoAsOfflineMutation();
  const [data, setdata] = useState({
    images: [],
    videos: [],
    live: [],
    activeIndex: 0,
    run: false,
    widgets: [],
  });
  const [totalprogress, settotalprogress] = useState(0);
  const [isloadingWhileUpload, setisloadingWhileUpload] = useState(false);

  const handleIndexChange = (index) => {
    setdata({ ...data, activeIndex: index });
  };

  const getAllMediaFunc = useCallback(async () => {
    try {
      const Mediadata = new FormData();
      Mediadata.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      Mediadata.append("security_token", await GetCookie("es_token"));
      const res = await getMedia(Mediadata).unwrap();

      if (
        res.message === "Media available" &&
        res.status === "true" &&
        res.connection === "true"
      ) {
        captureeventbaseanalytics(
          "Media",
          "getMedia.php RESPONSE",
          res.message
        );
        setdata((previousvalue) => ({
          ...previousvalue,
          images: res?.data?.filter(
            (image) => image.txt_media_file_type === "Image"
          ),
          videos: res?.data?.filter(
            (video) => video.txt_media_file_type === "Video"
          ),
          live: res?.data?.filter(
            (live) => live.txt_media_file_type === "Live"
          ),
          widgets: res?.data?.filter(
            (widget) => widget.txt_media_file_type === "Widget"
          ),
        }));
      } else if (res?.message === "No media available") {
        setdata((previousvalue) => ({
          ...previousvalue,
          images: [],
          videos: [],
          live: [],
          widgets: [],
        }));
      } else {
        captureeventbaseanalytics(
          "Media",
          "getMedia.php RESPONSE",
          res.message
        );
      }
    } catch (error) {
      console.log(error);
      toast.error(error.error);
      captureeventbaseanalytics("Media", "getMedia.php RESPONSE", error.error);
    }
  }, [getMedia]);

  const handleEnquireMedia = (media) => {
    swal({
      title: "Media Delete!",
      text: "Once Deleted, you will not be able to recover!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willUnLink) => {
      if (willUnLink) {
        const payload = new FormData();
        payload.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );
        payload.append("security_token", await GetCookie("es_token"));
        payload.append("ser_media_id", media.ser_media_id);

        if (
          media.ser_media_id === "null" ||
          media.ser_media_id === "" ||
          media.ser_media_id === null ||
          media.ser_media_id === "undefined" ||
          media.ser_media_id === undefined ||
          media.ser_media_id === "N/A"
        ) {
          toast.error("Media is not available");
        } else {
          try {
            const res = await enquireMedia(payload).unwrap();
            if (
              res.connection === "true" &&
              res.status === "true" &&
              res.message === "Media available. Ready to delete."
            ) {
              captureeventbaseanalytics(
                "Media",
                "enquireMedia.php RESPONSE",
                res.message
              );
              payload.append("doc_name", media.txt_media_name);
              try {
                const response = await DeleteMedia(payload).unwrap();
                if (
                  response.connection === "true" &&
                  response.status === "true" &&
                  response.message === "File deleted successfully"
                ) {
                  captureeventbaseanalytics(
                    "Media",
                    "DeleteMedia.php RESPONSE",
                    response.message
                  );
                  toast.success(response.message);
                  getAllMediaFunc();
                } else if (
                  response.connection === "true" &&
                  response.status === "true" &&
                  response.message === "Live deleted successfully"
                ) {
                  captureeventbaseanalytics(
                    "Media",
                    "DeleteMedia.php RESPONSE",
                    response.message
                  );
                  toast.success(response.message);
                  getAllMediaFunc();
                } else {
                  captureeventbaseanalytics(
                    "Media",
                    "DeleteMedia.php RESPONSE",
                    response.message
                  );
                  toast.error(response.message);
                  getAllMediaFunc();
                }
              } catch (error) {
                console.log(error);
                toast.error(error.error);
                captureeventbaseanalytics(
                  "Media",
                  "DeleteMedia.php RESPONSE",
                  error.message
                );
              }
            } else if (
              res.connection === "true" &&
              res.status === "false" &&
              res.message ===
                "Media associated with other posts. This causes inconvience during posts playing to screens."
            ) {
              toast.info(res.message);
              captureeventbaseanalytics(
                "Media",
                "enquireMedia.php RESPONSE",
                res.message
              );
            } else {
              captureeventbaseanalytics(
                "Media",
                "enquireMedia.php RESPONSE",
                res.message
              );
              toast.error(res.message);
            }
          } catch (error) {
            console.log(error);
            toast.error(error.error);
            captureeventbaseanalytics(
              "Media",
              "enquireMedia.php RESPONSE",
              error.message
            );
          }
        }
      }
    });
  };

  const handleMediaAsOffline = async (media) => {
    try {
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("ser_media_id", media.ser_media_id);
      payload.append("txt_media_offline_status", !media.is_offline_available);

      const res = await addMediatoAsOffline(payload).unwrap();
      if (res.connection === "true" && res.status === "true") {
        toast.success(res.message);
        getAllMediaFunc();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.status);
    }
  };

  useEffect(() => {
    capturepageanalytics(window.location.pathname);
    getAllMediaFunc();
  }, [getAllMediaFunc]);

  const onUploadProgress = (event) => {
    const percentCompleted = Math.round((event.loaded * 100) / event.total);
    settotalprogress(percentCompleted);
    if (percentCompleted === 100) {
      setTimeout(() => {
        settotalprogress(0);
      }, 400);
    }
  };
  const handleChange = async (file) => {
    if (file?.size >= MAX_UPLOAD_FILE_SIZE) {
      toast.info("Max file upload size is 500Mb");
    } else {
      setisloadingWhileUpload(true);
      const mediadata = new FormData();
      mediadata.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      mediadata.append("security_token", await GetCookie("es_token"));
      mediadata.append("upload_type", "File");
      mediadata.append("myFile", file);
      try {
        const returned = await axios.post(
          CONTENT_BASEURL + "boostboard-content/addMedia.php",
          mediadata,
          { onUploadProgress }
        );
        if (
          returned.data.status === "true" &&
          returned.data.connection === "true" &&
          returned.data.message === "File uploaded successfully"
        ) {
          setisloadingWhileUpload(false);
          captureeventbaseanalytics(
            "Media",
            "postMedia.php upload_type:File RESPONSE",
            returned.data.message
          );
          toast.success(returned.data.message);
          getAllMediaFunc();
          if (file.type !== "video/mp4") {
            handleIndexChange(0);
          } else {
            handleIndexChange(1);
          }
        } else {
          setisloadingWhileUpload(false);
          toast.error(returned.data.message);
          captureeventbaseanalytics(
            "Media",
            "postMedia.php upload_type:File RESPONSE",
            returned.data.message
          );
        }
      } catch (error) {
        console.error(error);
        setisloadingWhileUpload(false);
        toast.error(error.message);
        captureeventbaseanalytics(
          "Media",
          "postMedia.php upload_type:File RESPONSE",
          error.message
        );
      }
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  // const handleChange = async (files) => {
  //   const selectedFiles = Array.from(files); 
  
  //   for (const file of selectedFiles) {
  //     if (file?.size >= MAX_UPLOAD_FILE_SIZE) {
  //       toast.info("Max file upload size is 500Mb");
  //     } else {
  //       setisloadingWhileUpload(true);
  //       const mediadata = new FormData();
  //       mediadata.append(
  //         "txt_customer_id",
  //         localStorage.getItem("txt_customer_id")
  //       );
  //       mediadata.append("security_token", await GetCookie("es_token"));
  //       mediadata.append("upload_type", "File");
  //       mediadata.append("myFile", file);
  //       try {
  //         const returned = await axios.post(
  //           CONTENT_BASEURL + "boostboard-content/addMedia.php",
  //           mediadata,
  //           { onUploadProgress }
  //         );
  //         if (
  //           returned.data.status === "true" &&
  //           returned.data.connection === "true" &&
  //           returned.data.message === "File uploaded successfully"
  //         ) {
  //           setisloadingWhileUpload(false);
  //           captureeventbaseanalytics(
  //             "Media",
  //             "postMedia.php upload_type:File RESPONSE",
  //             returned.data.message
  //           );
  //           toast.success(returned.data.message);
  //           getAllMediaFunc();
  //           if (file.type !== "video/mp4") {
  //             handleIndexChange(0);
  //           } else {
  //             handleIndexChange(1);
  //           }
  //         } else {
  //           setisloadingWhileUpload(false);
  //           toast.error(returned.data.message);
  //           captureeventbaseanalytics(
  //             "Media",
  //             "postMedia.php upload_type:File RESPONSE",
  //             returned.data.message
  //           );
  //         }
  //       } catch (error) {
  //         console.error(error);
  //         setisloadingWhileUpload(false);
  //         toast.error(error.message);
  //         captureeventbaseanalytics(
  //           "Media",
  //           "postMedia.php upload_type:File RESPONSE",
  //           error.message
  //         );
  //       }
  //     }
  //   }
  
  //   if (fileInputRef.current) {
  //     fileInputRef.current.value = null;
  //   }
  // };

  const isShow =
    (data?.images?.length > 0 && data?.activeIndex === 0) ||
    (data?.videos?.length > 0 && data?.activeIndex === 1);
  return (
    <>
      {isLoading || loading || isloadingWhileUpload ? (
        <LoadingSpinner totalprogress={totalprogress} />
      ) : null}
      <Box sx={{ flexGrow: 1, mr: 3, mt: 1 }}>
        <Box sx={{ mt: 2 }} className="media_tabview_box">
          <TabView
            activeIndex={data?.activeIndex}
            onTabChange={(e) => handleIndexChange(e.index)}
          >
            <TabPanel header="Images" className="images">
              <GetAllImagesFromCloud
                images={data?.images}
                handleEnquireMedia={handleEnquireMedia}
                handleMediaAsOffline={handleMediaAsOffline}
                handleIndexChange={handleIndexChange}
                getAllMediaFunc={getAllMediaFunc}
              />
            </TabPanel>
            <TabPanel header="Videos" className="videos">
              <GetAllVideosFromCloud
                videos={data?.videos}
                handleEnquireMedia={handleEnquireMedia}
                handleMediaAsOffline={handleMediaAsOffline}
                handleIndexChange={handleIndexChange}
                getAllMediaFunc={getAllMediaFunc}
              />
            </TabPanel>
            {/* <TabPanel header="Live" className="live">
              <GetAllLiveStreamsFromCloud
                live={data?.live}
                getAllMediaFunc={getAllMediaFunc}
                handleEnquireMedia={handleEnquireMedia}
              />
            </TabPanel> */}
            {/* <TabPanel header="Widgets" className="widgets">
              <Widgets widgets={data?.widgets} />
            </TabPanel> */}
          </TabView>
          {isShow ? (
          //   <Box position={"absolute"} top={"42px"} right={"40px"}>
          //   <Button
          //     variant="contained"
          //     style={{ float: "right" }}
          //     startIcon={<UploadIcon />}
          //     component="label"
          //   >
          //     Upload
          //     <input
          //       type="file"
          //       hidden
          //       ref={fileInputRef}
          //       onChange={(e) => handleChange(e.target.files)} 
          //       multiple 
          //     />
          //   </Button>
          // </Box>
          <Box position={"absolute"} top={"42px"} right={"40px"}>
          <Button
            variant="contained"
            className="capitalized fs-14 fw-bold"
            style={{ float: "right" }}
            startIcon={<UploadIcon />}
            component="label"
            
          >
            Upload
            <input
              type="file"
              hidden
              ref={fileInputRef}
              onChange={(e) => handleChange(e.target.files[0])}
            />
          </Button>
        </Box>
          ) : null}
        </Box>
      </Box>
    </>
  );
};

export default memo(Media);
